import { setSASApplicationNameHeader } from '../axios/interceptors/sas-app-name-header';
import { axios } from '../internal';
const cache = {};
const config = {};
let isConfigInitialized = false;
let isConfigInitializing = false;
async function getConfigurations(url) {
  const basicHeader = {
    Accept: 'application/json',
    crossDomain: 'false',
    authenticate: 'true'
  };
  const response = await axios.get(url, basicHeader);
  if (response.status !== 200) {
    throw new Error(`Failed to fetch configurations ${url}`);
  }
  return await response.data;
}
export async function getConfiguration() {
  return initConfiguration({});
}
export async function initConfiguration(configJson) {
  if (isConfigInitialized) return Promise.resolve(config);
  let url = `ui/configurations`;
  let disableConfigurationEndPoint = false;
  if (configJson) {
    let k;
    for (k in configJson) {
      const lk = k.toLowerCase();
      if (lk === 'configurationendpoint') {
        url = configJson[k].toString();
      }
      if (lk === 'disableconfigurationendpoint') {
        disableConfigurationEndPoint = !!configJson[k];
      }
    }
  }
  const setValue = function (name, value) {
    if (typeof value === 'undefined' || value === null) {
      return;
    }
    // normalize property case.
    name = name.toLowerCase();
    switch (typeof value) {
      case 'boolean':
        // boolean etc.
        config[name] = !!value;
        break;
      case 'string':
        config[name] = `${value}`; // enforce string
        break;
      case 'number':
        config[name] = value; // enforce integer
        break;
      case 'function':
        if (typeof value !== 'function') {
          throw new Error('unsupported value');
        }
        config[name] = value;
        break;
      case 'object':
        if (Array.isArray(value)) {
          config[name] = value;
        } else if (typeof value === 'object') {
          config[name] = value;
          // TODO Review: I think we are trying to simplify nested property access.
          // Should we refrain from doing so? Consumer supplying an object can access
          // the property as object.
          let k;
          for (k in value) {
            setValue(`${name}.${k}`, value[k]);
          }
        } else {
          throw new Error('unsupported value');
        }
        break;
      default:
        throw new Error('illegal state');
    }
  };
  const applySettingsFromConfigJson = function () {
    let k;
    for (k in configJson) {
      setValue(k, configJson[k]);
    }
  };
  const applySettingsFromUrl = function () {
    // apply the settings from the url
    const urlPrefix = 'nova-';
    const uriParams = new URLSearchParams(window.location.href);
    if (uriParams) {
      // now analyze nova- parameters
      for (const n in config) {
        const value = uriParams.get(urlPrefix + n);
        if (value === '' || `${value}` === '') {
          // empty URL parameters set the parameter back to its system default
          config[n] = undefined;
        } else {
          // sets the value (null or empty value ignored)
          setValue(n, value);
        }
      }
    }
  };
  const addGenericMethods = function () {
    // add a generic method to return non common config.
    config.get = function (property) {
      return config[property.toLowerCase()];
    };
  };
  const initializedConfig = function () {
    isConfigInitialized = true;
    isConfigInitializing = false;

    // set app name header for SAS auditing
    setSASApplicationNameHeader(config.get('appName'));
    return config;
  };
  if (disableConfigurationEndPoint) {
    applySettingsFromConfigJson();
    applySettingsFromUrl();
    addGenericMethods();
    return Promise.resolve(initializedConfig());
  }

  // Check to see if we have a pending Promise, and if so, return that Promise
  let n;
  for (n in cache) {
    if (n.indexOf(url) !== -1) return cache[n];
  }
  if (isConfigInitializing) return cache[url];
  isConfigInitializing = true;
  return cache[url] = getConfigurations(url).then(oData => {
    delete cache[url];
    applySettingsFromConfigJson();
    let k;
    for (k in oData) {
      setValue(k, oData[k]);
    }
    applySettingsFromUrl();
    addGenericMethods();
    return initializedConfig();
  }).catch(error => {
    delete cache[url];
    // eslint-disable-next-line @sas/i18n/jsx-to-localize
    console.error(`Fetch configurations failed -${error}`);
    // still attempt to populate config from other sources
    applySettingsFromConfigJson();
    applySettingsFromUrl();
    addGenericMethods();
    return initializedConfig();
  });
}
//# sourceMappingURL=Configuration.js.map